import { render, staticRenderFns } from "./PrepareTraining.vue?vue&type=template&id=b66ec668"
import script from "./prepare-training.js?vue&type=script&lang=js&external"
export * from "./prepare-training.js?vue&type=script&lang=js&external"
import style0 from "./PrepareTraining.vue?vue&type=style&index=0&id=b66ec668&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/jenkins_workspace/workspace/vuejs-tb-train-ontraining-web-sim/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b66ec668')) {
      api.createRecord('b66ec668', component.options)
    } else {
      api.reload('b66ec668', component.options)
    }
    module.hot.accept("./PrepareTraining.vue?vue&type=template&id=b66ec668", function () {
      api.rerender('b66ec668', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/prepare-training/PrepareTraining.vue"
export default component.exports